import {
	Injectable,
	ComponentRef,
	createComponent,
	ApplicationRef,
	EnvironmentInjector,
} from '@angular/core';
import { ToastComponent } from '../components/toast/toast.component';
import { ToastOptions } from '../models/toast.model';

@Injectable({
	providedIn: 'root',
})
export class ToastService {
	private toastComponentRef: ComponentRef<ToastComponent> | null = null;

	constructor(
		private appRef: ApplicationRef,
		private injector: EnvironmentInjector,
	) {}

	private initializeToastComponent() {
		if (!this.toastComponentRef) {
			// Create the component
			this.toastComponentRef = createComponent(ToastComponent, {
				environmentInjector: this.injector,
			});

			// Add to the DOM
			document.body.appendChild(this.toastComponentRef.location.nativeElement);

			// Attach to the application change detector
			this.appRef.attachView(this.toastComponentRef.hostView);
		}
	}

	showError(message: string, duration: number = 5000) {
		this.initializeToastComponent();
		this.toastComponentRef?.instance.addToast({
			message,
			duration,
			type: 'error',
		});
	}

	showSuccess(message: string, duration: number = 5000) {
		this.initializeToastComponent();
		this.toastComponentRef?.instance.addToast({
			message,
			duration,
			type: 'success',
		});
	}

	showToast({ message, duration, type }: ToastOptions) {
		this.initializeToastComponent();
		this.toastComponentRef?.instance.addToast({
			message,
			duration,
			type,
		});
	}

	// Optional: Method to clear all toasts
	clearAll() {
		if (this.toastComponentRef) {
			this.toastComponentRef.instance.toasts = [];
		}
	}
}
